import React from 'react';
import moment from 'moment';
import { ErrorMessage } from './ErrorMessage';
import { FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';

export const formatDate = (val) => {
  return moment(val).format('MM/DD/YYYY');
};

export const getValue = (values) => {
  const a = values?.split(' ')?.join('');
  const dateValue = values?.length > 1 ? values?.slice(0, 5) : '';
  if (dateValue?.toUpperCase() === 'TODAY') {
    return a?.replace(dateValue, 'cast(now()as date)');
  } else if (values?.charAt(0)?.toUpperCase() === 'T') {
    return a?.replace(values?.charAt(0), 'cast(now()as date)');
  } else {
    return `'${values}'`;
  }
};

export const getOptions = (type) => {
  switch (type) {
  case 'text':
  case 'ssn':
  case 'phone':
    return [
      { label: 'Is', value: '=' },
      { label: 'Is not', value: '<>' },
      { label: 'Contain', value: 'contains' },
      { label: "Doesn't contain", value: 'notContains' },
      { label: 'In', value: 'in' },
      { label: 'Not in', value: 'notIn' },
      { label: 'Starts with', value: 'startsWith' },
      { label: 'Ends with', value: 'endsWith' },
      { label: 'Is Blank', value: 'isBlank' },
      { label: 'Is Not Blank', value: 'isNotBlank' },
    ];
  case 'number':
  case 'amount':
    return [
      { label: 'Is', value: '=' },
      { label: 'Is not', value: '<>' },
      { label: 'Less than', value: '<' },
      { label: 'Greater than', value: '>' },
      { label: 'Less than equal', value: '<=' },
      { label: 'Greater than equal', value: '>=' },
      { label: 'Between', value: 'BETWEEN' },
      { label: 'Not between', value: 'NOT BETWEEN' },
      { label: 'Is Blank', value: 'isBlank' },
      { label: 'Is Not Blank', value: 'isNotBlank' },
    ];
  case 'date':
    return [
      { label: 'Is', value: '=' },
      { label: 'Is not', value: '<>' },
      { label: 'Less than', value: '<' },
      { label: 'Greater than', value: '>' },
      { label: 'Less than equal', value: '<=' },
      { label: 'Greater than equal', value: '>=' },
      { label: 'Between', value: 'BETWEEN' },
      { label: 'Not between', value: 'NOT BETWEEN' },
      { label: 'Is Blank', value: 'isBlank' },
      { label: 'Is Not Blank', value: 'isNotBlank' },
    ];
  default:
    return [
      { label: 'Is', value: '=' },
      { label: 'Is not', value: '<>' },
      { label: 'Contain', value: 'contains' },
      { label: "Doesn't contain", value: 'notContains' },
      { label: 'In', value: 'in' },
      { label: 'Not in', value: 'notIn' },
      { label: 'Starts with', value: 'startsWith' },
      { label: 'Ends with', value: 'endsWith' },
      { label: 'Is Blank', value: 'isBlank' },
      { label: 'Is Not Blank', value: 'isNotBlank' },
    ];
  }
};

export const getDataManagerOptions = (type) => {
  switch (type) {
  case 'text':
  case 'ssn':
  case 'phone':
    return [
      { label: 'Is', value: '=' },
      { label: 'Is not', value: '<>' },
      { label: 'Contain', value: 'contains' },
      { label: "Doesn't contain", value: 'notContains' },
      { label: 'In', value: 'in' },
      { label: 'Not in', value: 'notIn' },
      { label: 'Starts with', value: 'startsWith' },
      { label: 'Ends with', value: 'endsWith' },
      { label: 'Is Blank', value: 'isBlank' },
      { label: 'Is Not Blank', value: 'isNotBlank' },
      { label: "Doesn't Starts with", value: 'notStartsWith' },
    ];
  case 'number':
  case 'amount':
    return [
      { label: 'Is', value: '=' },
      { label: 'Is not', value: '<>' },
      { label: 'Less than', value: '<' },
      { label: 'Greater than', value: '>' },
      { label: 'Less than equal', value: '<=' },
      { label: 'Greater than equal', value: '>=' },
      { label: 'Between', value: 'BETWEEN' },
      { label: 'Not between', value: 'NOT BETWEEN' },
      { label: 'Is Blank', value: 'isBlank' },
      { label: 'Is Not Blank', value: 'isNotBlank' },
    ];
  case 'date':
    return [
      { label: 'Is', value: '=' },
      { label: 'Is not', value: '<>' },
      { label: 'Less than', value: '<' },
      { label: 'Greater than', value: '>' },
      { label: 'Less than equal', value: '<=' },
      { label: 'Greater than equal', value: '>=' },
      { label: 'Between', value: 'BETWEEN' },
      { label: 'Not between', value: 'NOT BETWEEN' },
      { label: 'Is Blank', value: 'isBlank' },
      { label: 'Is Not Blank', value: 'isNotBlank' },
    ];
  default:
    return [
      { label: 'Is', value: '=' },
      { label: 'Is not', value: '<>' },
      { label: 'Contain', value: 'contains' },
      { label: "Doesn't contain", value: 'notContains' },
      { label: 'In', value: 'in' },
      { label: 'Not in', value: 'notIn' },
      { label: 'Starts with', value: 'startsWith' },
      { label: 'Ends with', value: 'endsWith' },
      { label: 'Is Blank', value: 'isBlank' },
      { label: 'Is Not Blank', value: 'isNotBlank' },
    ];
  }
};
export const getWorkqueueFilterOptions = (type) => {
  switch (type) {
  case 'text':
  case 'ssn':
  case 'phone':
    return [
      { label: 'is', value: '=', textVal: 'is' },
      { label: 'is not', value: '<>', textVal: 'isNot' },
      { label: 'contain', value: 'contains', textVal: 'contains' },
      { label: 'is null', value: 'isNull', textVal: 'isNull' },
      { label: 'is not null', value: 'isNotNull', textVal: 'isNotNull' },
    ];
  case 'number':
  case 'date':
  case 'amount':
    return [
      { label: 'is', value: '=', textVal: 'is' },
      { label: 'is not', value: '<>', textVal: 'isNot' },

      { label: 'less than', value: '<', textVal: 'lessThan' },
      { label: 'greater than', value: '>', textVal: 'greaterThan' },
      { label: 'less than equal', value: '<=', textVal: 'lessThanEqual' },
      { label: 'greater than equal', value: '>=', textVal: 'greaterThanEqual' },
      { label: 'between', value: 'BETWEEN', textVal: 'between' },
      { label: 'not between', value: 'NOT BETWEEN', textVal: 'notBetween' },
      { label: 'is null', value: 'isNull', textVal: 'isNull' },
      { label: 'is not null', value: 'isNotNull', textVal: 'isNotNull' },
    ];
  default:
    return [
      { label: 'is', value: '=', textVal: 'is' },
      { label: 'is not', value: '<>', textVal: 'isNot' },
      { label: 'contain', value: 'contains', textVal: 'contains' },
      { label: 'is null', value: 'isNull', textVal: 'isNull' },
      { label: 'is not null', value: 'isNotNull', textVal: 'isNotNull' },
    ];
  }
};

export const getFields = ({ type, rule, handleUpdateRule, name, name1, error, handleBlur }) => {
  const hideValuesConditions = ['isBlank', 'isNotBlank', 'isEmpty', 'isNotEmpty'];
  const valueErrorMesg = (
    <ErrorMessage
      render={(msg) => (
        <div
          className="error-text"
          style={{ color: 'red', position: 'absolute', marginTop: '4px' }}
        >
          {msg}
        </div>
      )}
      name={name}
    />
  );
  const commonProps = {
    handleBlur,
    fullWidth: true,
  };
  const value1ErrorMesg = (
    <ErrorMessage
      render={(msg) => (
        <div
          className="error-text"
          style={{ color: 'red', position: 'absolute', marginTop: '4px' }}
        >
          {msg}
        </div>
      )}
      name={name1}
    />
  );
  if (!hideValuesConditions.includes(rule.condition.value)) {
    switch (type) {
    case 'text':
      return (
        <div>
          { rule?.listType?.toLowerCase() === 'fixed' && 
          typeof rule.listValue !== 'undefined' && 
          rule.listValue ? (
              <>
                <FormControl fullWidth>
                  <InputLabel id={`select-label-${name}`}>Select</InputLabel>
                  <Select
                    {...commonProps}
                    labelId={`select-label-${name}`}
                    value={rule.value ? rule.value.split(',') : []}
                    name={name}
                    multiple
                    onChange={(e) => {
                      const selectedValues = e.target.value;
                      handleUpdateRule('value', selectedValues.join(','));
                    }}
                  >
                    {rule.listValue.split(',').map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </>
            ) : (
              <TextField
                {...commonProps}
                label="Value"
                value={rule.value}
                name={name}
                placeholder="Enter text"
                error={error}
                onChange={(e) => {
                  handleUpdateRule('value', e.target.value);
                }}
              />
            )}
          {valueErrorMesg}
        </div>
      );
    case 'ssn':
    case 'phone':
      return (
        <div>
          <TextField
            {...commonProps}
            label="Value"
            value={rule.value}
            name={name}
            placeholder="Enter text"
            error={error}
            onChange={(e) => {
              handleUpdateRule('value', e.target.value);
            }}
          />
          {valueErrorMesg}
        </div>
      );
    case 'number':
    case 'amount':
      if (rule.condition.value == 'BETWEEN') {
        return (
          <div className="d-flex align-items-center col-md-6 col-lg-4">
            {/* <div className="label-text mr-10">From</div> */}
            <div className="form-group px-3">
              <TextField
                {...commonProps}
                type="number"
                placeholder="Enter number"
                // variant="outlined"
                value={rule.value}
                name={name}
                label="From"
                error={error}
                // InputLabelProps={{
                //   shrink: true,
                // }}
                // inputProps={{
                //   style: {
                //     height: "0px",
                //   },
                // }}
                onChange={(e) => {
                  handleUpdateRule('value', e.target.value);
                }}
              />
              {valueErrorMesg}
            </div>
            {/* <div className="label-text">To</div> */}
            <div className="form-group px-3">
              <TextField
                {...commonProps}
                value={rule.value1}
                type="number"
                placeholder="Enter number"
                label="To"
                // variant="outlined"
                name={`${name}.value1`}
                // InputLabelProps={{
                //   shrink: true,
                // }}
                // inputProps={{
                //   style: {
                //     height: "0px",
                //   },
                // }}
                onChange={(e) => {
                  handleUpdateRule('value1', e.target.value);
                }}
              />
              {value1ErrorMesg}
            </div>
          </div>
        );
      } else if (rule.condition.value == 'NOT BETWEEN') {
        return (
          <div className="d-flex align-items-center col-md-6 col-lg-4">
            {/* <div className="start-num"></div> */}
            {/* <div className="label-text mr-10">From</div> */}
            <div className="form-group px-3">
              <TextField
                // label="Value"
                {...commonProps}
                type="number"
                name={name}
                label="From"
                placeholder="Enter number"
                // variant="outlined"
                value={rule.value}
                error={error}
                // InputLabelProps={{
                //   shrink: true,
                // }}
                // inputProps={{
                //   style: {
                //     height: "0px",
                //   },
                // }}
                onChange={(e) => {
                  handleUpdateRule('value', e.target.value);
                }}
              />
              {valueErrorMesg}
            </div>
            {/* <div className="label-text and-value-text">and</div> */}
            {/* <div className="label-text">To</div> */}
            <div className="form-group px-3">
              <TextField
                {...commonProps}
                value={rule.value1}
                type="number"
                label="To"
                placeholder="Enter number"
                // variant="outlined"
                name={`${name}.value1`}
                // InputLabelProps={{
                //   shrink: true,
                // }}
                // inputProps={{
                //   style: {
                //     height: "0px",
                //   },
                // }}
                onChange={(e) => {
                  handleUpdateRule('value1', e.target.value);
                }}
              />
              {value1ErrorMesg}
            </div>
          </div>
        );
      } else {
        return (
          <div>
            <TextField
              {...commonProps}
              label="Value"
              value={rule.value}
              name={name}
              type="number"
              error={error}
              placeholder="Enter number"
              onChange={(e) => {
                handleUpdateRule('value', e.target.value);
              }}
            />
            {valueErrorMesg}
          </div>
        );
      }
    case 'date':
      if (rule.condition.value == 'BETWEEN') {
        return (
          <div className="d-flex col-md-6 col-lg-4 align-items-center form-group">
            {/* <div className="label-text m-0 mr-10">From</div> */}
            <div>
              <TextField
                margin="dense"
                // variant="outlined"
                // className={` ${classes.labelName} ${classes.inputLabel}`}
                placeholder={`MM/DD/YYYY or Today or T`}
                label="From Field Value"
                // InputLabelProps={{
                //   shrink: true,
                // }}
                // InputProps={{
                //   startAdornment: <InputAdornment position="start">T</InputAdornment>,
                //   // inputComponent: NumberFormatterPostiveNegavtive,
                // }}
                name={name}
                value={rule.value}
                onChange={(e) => {
                  handleUpdateRule('value', e.target?.value.toUpperCase());
                }}
                fullWidth
                onBlur={handleBlur}
                error={error}
              />
              {/* <KeyboardDatePicker
                  {...commonProps}
                  format="MM/dd/yyyy"
                  placeholder="MM/DD/YYYY"
                  fullWidth
                  name={name}
                  value={rule.value}
                  // minDate={new Date(moment(dateValidationData).add(1, "days").format("YYYY-MM-DD"))}
                  // name="effectiveDate"
                  minDateMessage={null}
                  error={error}
                  helperText={null}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  // inputVariant="outlined"
                  label="From"
                  onChange={(val) => {
                    handleUpdateRule("value", val);
                  }}
                  autoOk
                  margin="dense"
                /> */}
              {valueErrorMesg}
            </div>
            <div className="label-text and-datepicker-text">and</div>
            {/* <div className="label-text">To</div> */}
            <div className="ml-2">
              <TextField
                margin="dense"
                // variant="outlined"
                // className={` ${classes.labelName} ${classes.inputLabel}`}
                placeholder={`MM/DD/YYYY or Today or T`}
                label="To Field Value"
                // InputLabelProps={{
                //   shrink: true,
                // }}
                // InputProps={{
                //   startAdornment: <InputAdornment position="start">T</InputAdornment>,
                //   // inputComponent: NumberFormatterPostiveNegavtive,
                // }}
                name={`${name}.value1`}
                value={rule.value1}
                onChange={(e) => {
                  handleUpdateRule('value1', e.target?.value.toUpperCase());
                }}
                fullWidth
                onBlur={handleBlur}
                error={error}
              />
              {/* <KeyboardDatePicker
                {...commonProps}
                format="MM/dd/yyyy"
                placeholder="MM/DD/YYYY"
                fullWidth
                value={rule.value1}
                // minDate={new Date(moment(dateValidationData).add(1, "days").format("YYYY-MM-DD"))}
                // name="effectiveDate"
                minDateMessage={null}
                name={`${name}.value1`}
                error={error}
                helperText={null}
                InputLabelProps={{
                  shrink: true,
                }}
                // inputVariant="outlined"
                label="To"
                onChange={(val) => {
                  handleUpdateRule("value1", val);
                }}
                autoOk
                margin="dense"
              /> */}
              {value1ErrorMesg}
            </div>
          </div>
        );
      } else if (rule.condition.value == 'NOT BETWEEN') {
        return (
          <div className="d-flex col-md-6 col-lg-4 align-items-center form-group">
            <div>
              {/* <KeyboardDatePicker
                  // className={` ${classes.labelName} ${classes.datePicker}`}
                  {...commonProps}
                  format="MM/dd/yyyy"
                  placeholder="MM/DD/YYYY"
                  fullWidth
                  name={name}
                  value={rule.value}
                  // minDate={new Date(moment(dateValidationData).add(1, "days").format("YYYY-MM-DD"))}
                  // name="effectiveDate"
                  minDateMessage={null}
                  error={error}
                  helperText={null}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  // inputVariant="outlined"
                  label="Value"
                  onChange={(val) => {
                    handleUpdateRule("value", val);
                  }}
                  autoOk
                  margin="dense"
                /> */}
              <TextField
                margin="dense"
                // variant="outlined"
                // className={` ${classes.labelName} ${classes.inputLabel}`}
                placeholder={`MM/DD/YYYY or Today or T`}
                label="From Field Value"
                // InputLabelProps={{
                //   shrink: true,
                // }}
                // InputProps={{
                //   startAdornment: <InputAdornment position="start">T</InputAdornment>,
                //   // inputComponent: NumberFormatterPostiveNegavtive,
                // }}
                name={name}
                value={rule.value}
                onChange={(e) => {
                  handleUpdateRule('value', e.target?.value.toUpperCase());
                }}
                fullWidth
                onBlur={handleBlur}
                error={error}
              />
              {valueErrorMesg}
            </div>
            <div className="label-text and-datepicker-text">and</div>
            <div>
              {/* <KeyboardDatePicker
                  // className={` ${classes.labelName} ${classes.datePicker}`}
                  {...commonProps}
                  format="MM/dd/yyyy"
                  placeholder="MM/DD/YYYY"
                  fullWidth
                  value={rule.value1}
                  // minDate={new Date(moment(dateValidationData).add(1, "days").format("YYYY-MM-DD"))}
                  name={`${name}.value1`}
                  minDateMessage={null}
                  error={false}
                  helperText={null}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  // inputVariant="outlined"
                  label="Value"
                  onChange={(val) => {
                    handleUpdateRule("value1", val);
                  }}
                  autoOk
                  margin="dense"
                /> */}
              <TextField
                margin="dense"
                // variant="outlined"
                // className={` ${classes.labelName} ${classes.inputLabel}`}
                placeholder={`MM/DD/YYYY or Today or T`}
                label="To Field Value"
                // InputLabelProps={{
                //   shrink: true,
                // }}
                // InputProps={{
                //   startAdornment: <InputAdornment position="start">T</InputAdornment>,
                //   // inputComponent: NumberFormatterPostiveNegavtive,
                // }}
                name={`${name}.value1`}
                value={rule.value1}
                onChange={(e) => {
                  handleUpdateRule('value1', e.target?.value.toUpperCase());
                }}
                fullWidth
                onBlur={handleBlur}
                error={error}
              />
              {value1ErrorMesg}
            </div>
          </div>
        );
      }
      {
        return (
          <div>
            {/* <KeyboardDatePicker
                // className={` ${classes.labelName} ${classes.datePicker}`}
                {...commonProps}
                format="MM/dd/yyyy"
                placeholder="MM/DD/YYYY"
                fullWidth
                value={rule.value}
                // minDate={new Date(moment(dateValidationData).add(1, "days").format("YYYY-MM-DD"))}
                name={name}
                minDateMessage={null}
                error={error}
                helperText={null}
                InputLabelProps={{
                  shrink: true,
                }}
                // inputVariant="outlined"
                label="Value"
                onChange={(val) => {
                  handleUpdateRule("value", val);
                }}
                autoOk
                margin="dense"
              />
              {valueErrorMesg} */}
            <TextField
              margin="dense"
              // variant="outlined"
              // className={` ${classes.labelName} ${classes.inputLabel}`}
              placeholder={`MM/DD/YYYY or Today or T`}
              label="To Field Value"
              // InputLabelProps={{
              //   shrink: true,
              // }}
              // InputProps={{
              //   startAdornment: <InputAdornment position="start">T</InputAdornment>,
              //   // inputComponent: NumberFormatterPostiveNegavtive,
              // }}
              name={name}
              value={rule.value}
              onChange={(e) => {
                handleUpdateRule('value', e.target?.value?.toUpperCase());
              }}
              fullWidth
              onBlur={handleBlur}
              error={error}
            />
            {valueErrorMesg}
          </div>
        );
      }
    default:
      return (
        <div>
          <TextField
            {...commonProps}
            label="Value"
            value={rule.value}
            placeholder="Enter text"
            name={name}
            error={error}
            fullWidth
            onChange={(e) => {
              handleUpdateRule('value', e.target.value);
            }}
          />
          {valueErrorMesg}
        </div>
      );
    }
  }
  return;
};
const numberTypes = ['amount', 'number'];
export const generateSql = (obj) => {
  let sqlQuery = obj?.field?.globalField;
  if (typeof sqlQuery === 'undefined' || typeof obj.field.globalField === 'undefined') {
    sqlQuery = obj.fieldName.toLowerCase().replace(' ', '_');
    obj.field.globalField = sqlQuery;
  }

  const dontConvertLowerCase = ['date', 'number', 'amount'];
  let {
    value,
    value1,
    // condition: { value: conditionValue },
    condition,
  } = obj;
  const conditionValue = condition?.value ? condition.value : '';
  const currFieldType = obj?.field?.fieldType?.toLowerCase();

  if (value && currFieldType !== 'date') {
    value = value.toLowerCase();
  }

  if (value1 && currFieldType !== 'date') {
    value1 = value1.toLowerCase();
  }

  if (!dontConvertLowerCase.includes(currFieldType)) {
    sqlQuery = `lower(${obj?.field?.globalField})`;
  }

  if (conditionValue) {
    switch (conditionValue) {
    case '=':
      sqlQuery += ' = ';
      if (currFieldType === 'date') {
        // sqlQuery += " " + `'${formatDate(value)}'`;
        if (value?.charAt(0)?.toUpperCase() !== 'T') {
          // sqlQuery += " " + `'${value}'`;
          sqlQuery += ' ' + `'${value}'`;
        } else if (
          value?.slice(0, 5)?.toUpperCase() === 'TODAY' ||
            value?.charAt(0)?.toUpperCase() === 'T'
        ) {
          // sqlQuery += " " + " now() " + `${value}`;
          sqlQuery += `${getValue(value)}`;
        } else {
          sqlQuery += `'${value}'`;
        }
      } else if (value?.charAt(0)?.toUpperCase() !== 'T') {
        // sqlQuery += " " + `'${value}'`;
        sqlQuery += ' ' + `'${value}'`;
      } else {
        sqlQuery += ' ' + `'${value.toLowerCase()}'`;
      }
      break;
    case '<>':
      if (currFieldType === 'date') {
        sqlQuery = `( ${obj.field.globalField}`;
        sqlQuery += ' ' + conditionValue;
        if (value?.charAt(0)?.toUpperCase() !== 'T') {
          sqlQuery += `'${value}' or ${obj.field.globalField} is null )`;
          // sqlQuery += `'${value} or ${obj.field.globalField} is null )'`;
        } else if (
          value?.slice(0, 5)?.toUpperCase() === 'TODAY' ||
            value?.charAt(0)?.toUpperCase() === 'T'
        ) {
          // sqlQuery += " " + " now() " + `${value}`;
          sqlQuery += `${getValue(value)} or ${obj.field.globalField} is null )`;
        } else {
          // sqlQuery += ` now() ${value} or ${obj.field.globalField} is null )`;
          sqlQuery += `' ${value}' or ${obj.field.globalField} is null )`;
        }
      } else if (value?.charAt(0)?.toUpperCase() !== 'T') {
        sqlQuery = `( ${obj.field.globalField}`;
        sqlQuery += ' ' + conditionValue;
        sqlQuery += `'${value}' or ${obj.field.globalField} is null )`;
      } else {
        sqlQuery = `( ${obj.field.globalField}`;
        sqlQuery += ' ' + conditionValue;
        if (!dontConvertLowerCase.includes(currFieldType)) {
          sqlQuery = `( lower(${obj.field.globalField})`;
        }
        sqlQuery += ' ' + conditionValue;
        sqlQuery += ' ' + `'${value}' or ${obj.field.globalField} is null )`;
      }
      break;
    case 'contains':
      sqlQuery += ' LIKE ';
      sqlQuery += ` '%${value}%'`;

      break;
    case 'notContains':
      sqlQuery = `( ${obj.field.globalField}`;
      if (!dontConvertLowerCase.includes(currFieldType)) {
        sqlQuery = `( lower(${obj.field.globalField})`;
      }
      sqlQuery += ' NOT LIKE ';
      sqlQuery += ` '%${value}%'  or ${obj.field.globalField} is null )`;

      break;
    case 'startsWith':
      sqlQuery += ' LIKE ';
      sqlQuery += ` '${value}%'`;

      break;
    case 'endsWith':
      sqlQuery += ' LIKE ';
      sqlQuery += ` '%${value}'`;

      break;
    case 'BETWEEN':
    case 'NOT BETWEEN':
      if (currFieldType === 'date') {
        if (value?.charAt(0)?.toUpperCase() !== 'T' && value1?.charAt(0)?.toUpperCase() !== 'T') {
          sqlQuery += ' ' + conditionValue + ' ';
          sqlQuery += `'${value}' AND '${value1}'`;
        } else if (
          value?.slice(0, 5)?.toUpperCase() === 'TODAY' ||
            value?.charAt(0)?.toUpperCase() === 'T' ||
            value1?.slice(0, 5)?.toUpperCase() === 'TODAY' ||
            value1?.charAt(0)?.toUpperCase() === 'T'
        ) {
          // sqlQuery += " " + " now() " + `${value}`;
          sqlQuery += ' ' + conditionValue + ' ';
          sqlQuery += `${getValue(value)} AND ${getValue(value1)}`;
        }
      } else {
        sqlQuery += ' ' + conditionValue + ' ';
        sqlQuery += `${getValue(value)}` + ' AND ' + `${getValue(value1)}`;
      }
      break;

    case 'isBlank':
      if (currFieldType != 'date') {
        if (typeof obj.field.globalField === 'undefined') {
          sqlQuery = obj.sqlExpression;
        } else {
          sqlQuery = `( ${obj.field.globalField} IS NULL OR ${obj.field.globalField} = '' )`;
        }
      } else {
        sqlQuery = `( ${obj.field.globalField} IS NULL )`;
      }

      if (numberTypes.includes(currFieldType)) {
        sqlQuery = `( ${obj.field.globalField} IS NULL OR ${obj.field.globalField} = '0' )`;
      }

      break;
    case 'isNotBlank':
      if (currFieldType != 'date') {
        if (typeof obj.field.globalField === 'undefined') {
          // obj.field.globalField field is undefined causing errors on the Test Work Queues
          sqlQuery = sqlQuery = obj.sqlExpression;
        } else {
          sqlQuery = `( ${obj.field.globalField} IS NOT NULL AND ${obj.field.globalField} != '' )`;
        }
      } else {
        sqlQuery = `( ${obj.field.globalField} IS NOT NULL )`;
      }

      if (numberTypes.includes(currFieldType)) {
        sqlQuery = `( ${obj.field.globalField} IS NOT NULL AND ${obj.field.globalField} != '0' )`;
      }
      break;
    case 'in':
      if (typeof obj.field.globalField === 'undefined') {
        sqlQuery = obj.sqlExpression;
      } else {
        sqlQuery = obj.field.globalField;
        sqlQuery += ' IN (';
        const inSplitArr = value.split(',');
        inSplitArr.forEach((el, i) =>
          i === inSplitArr.length - 1
            ? (sqlQuery += `'${el?.trim()}'`)
            : (sqlQuery += `'${el?.trim()}',`),
        );
        sqlQuery += ')';
      }

      break;
    case 'notIn':
      if (typeof obj.field.globalField === 'undefined') {
        obj.field.globalField = obj.fieldName.toLowerCase().replace(' ', '_');
      }

      sqlQuery = `( ${obj.field.globalField}`;
      if (!dontConvertLowerCase.includes(currFieldType)) {
        sqlQuery = `( lower(${obj.field.globalField})`;
      }
      sqlQuery += ' NOT IN (';
      const splitArr = value.split(',');
      splitArr.forEach((el, i) =>
        i === splitArr.length - 1
          ? (sqlQuery += `'${el?.trim()}'`)
          : (sqlQuery += `'${el?.trim()}',`),
      );
      sqlQuery += `) or ${obj.field.globalField} is null )`;
      break;
    default:
      if (currFieldType === 'date') {
        sqlQuery += ' ' + conditionValue;
        if (value?.charAt(0)?.toUpperCase() !== 'T') {
          // sqlQuery += " " + `'${value}'`;
          sqlQuery += ' ' + `'${value}'`;
        } else if (
          value?.slice(0, 5)?.toUpperCase() === 'TODAY' ||
            value?.charAt(0)?.toUpperCase() === 'T'
        ) {
          // sqlQuery += " " + " now() " + `${value}`;
          sqlQuery += `${getValue(value)}`;
        } else {
          // sqlQuery += " " + " now() " + `${value}`;
          sqlQuery += `'${value}'`;
        }
      } else {
        sqlQuery += ' ' + conditionValue;
        sqlQuery += ' ' + `'${value}'`;
      }
    }
  }
  obj.sqlValue = sqlQuery;
};
